<wiz-vgroup width="100%" height="100%" gap="2" horizontalAlign="end" class="section-container">
  <wiz-hgroup width="100%" height="45px">
    <wiz-label #lbTitle width="100%" class="titleLabel" [wizLabel]="'$.freedata.form.choose.$'"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-ag-grid
  #agGrid
  width="100%"
  height="100%"
  class="ag-theme-alpine"
  [wizDatasource]="lineDS"
  wizRowSelection="single"></wiz-ag-grid>



  <!-- <wiz-list #liKey width="100%" height="100%" [wizLabelField]="'fullStr'" [wizDataProvider]="mainDS"></wiz-list> -->
  <wiz-hgroup width="100%" verticalAlign="end" horizontalAlign="space-between" gap="2">
    <filter-component #filter width="130px"> </filter-component>

    <wiz-button
      #btnSave
      [wizLabel]="'$.freedata.form.choose.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
